module.exports = __webpack_public_path__ + "media/images/sky1-9e39d1352d10606346a0592e1a26c62b.jpg";